import * as THREE from 'three'
import { useFrame, useThree } from '@react-three/fiber'
import { useAppStore } from 'startup/appStore'
import { useShallow } from 'zustand/react/shallow'

export default function AnimalPerspective() {

    const { camera } = useThree();

    const quaternion = new THREE.Quaternion();
    const newPosition = new THREE.Vector3();
    const distance = new THREE.Vector3(0, 0, 1);
    const lookAt = new THREE.Vector3();

    const {
        gameStatus,
        player,
        currentPosition,
        currentRotation,
    } = useAppStore(useShallow((state) => ({
        gameStatus: state.gameStatus,
        player: state.player,
        currentPosition: state.positions[state.player]?.current,
        currentRotation: state.rotations[state.player]
    })));

    useFrame(() => {
        if (
            currentPosition && (
                gameStatus === 'start' ||
                gameStatus === 'ending'
            )
        ) {
            //quaternion.setFromEuler(currentRotation);
            //camera.quaternion.copy(quaternion);
            ////camera.quaternion.slerp(quaternion, 0.9);

            //distance.set(0, 0, 1);
            //distance.applyQuaternion(quaternion);
            //newPosition.copy(currentPosition);
            //camera.position.copy(newPosition.add(distance.multiplyScalar(8)));
            ////camera.position.lerp(newPosition.add(distance.multiplyScalar(-8), 0.8));
            //camera.lookAt(currentPosition);

            newPosition.x = currentPosition.x;
            newPosition.y = currentPosition.y;
            newPosition.z = currentPosition.z + 15;
            camera.position.lerp(newPosition, 0.8);

            lookAt.x = currentPosition.x;
            lookAt.y = currentPosition.y;
            lookAt.z = currentPosition.z - 10;
            camera.lookAt(lookAt);
        }
    });

    return null;
};
